import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import ContactForm from "./ContactForm";
import { useWebData } from "../../Context/webDataContext";
import { FaPhoneAlt, FaEnvelope, FaLocationArrow } from "react-icons/fa";

const ContactUs = () => {
  const { getContactPageData } = useWebData();
  const contactData = getContactPageData();

  return (
    <>
      <div className="relative min-h-screen flex flex-col">
        <Navbar />
        <section className="px-4 md:px-16 lg:px-20 lg:py-10 mt-24 md:mt-5 flex-grow">
          {/* Heading & Subtitle */}
          <div className="text-center md:mb-8 mb-4">
            <h2 className="md:text-4xl text-2xl font-bold text-[#08875D] leading-tight">
              {contactData.contactHeading || "Get in Touch"}
            </h2>
            <p className="text-gray-700 md:text-4xl text-3xl max-w-2xl mx-auto mt-4">
              {contactData.contactSubHeading ||
                "We're here to help! Reach out to us for any inquiries, feedback, or support."}
            </p>
          </div>

          {/* Contact Info & Form */}
          <div className="flex flex-col lg:flex-row items-center md:gap-12 lg:gap-32 gap-8 my-8  lg:my-24">
            {/* Contact Information */}
            <div className="bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white lg:p-8 px-3 py-8 rounded-lg shadow-lg w-full lg:w-1/2 lg:min-h-[40vh] text-center lg:text-left">
              <h3 className="text-xl font-semibold mb-6">Get in Touch</h3>
              <div className="lg:space-y-8 space-y-4 flex flex-col lg:items-start items-center">
              <p className="flex lg:items-center items-start gap-1">
                 <FaPhoneAlt /> <strong>Call Today:</strong> {contactData.contactInfo.phone}
                </p>
                <p className="flex lg:items-center items-start gap-1">
                 <FaEnvelope /> <strong>Email:</strong> {contactData.contactInfo.email}
                </p>
                <p className="flex lg:items-center items-start gap-1">
                 <FaLocationArrow /> <strong>Address:</strong> {contactData.contactInfo.address}
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="w-full lg:w-1/2  rounded-2xl">
              <h3 className="text-2xl font-semibold text-[#08875D] mb-4 text-center">
                Send Us a Message
              </h3>
              <ContactForm />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default ContactUs;



// // src/components/contact/ContactUs.js
// import React from "react";
// import Navbar from "../navbar/Navbar";
// import Footer from "../footer/Footer";
// import ContactForm from "./ContactForm";
// import { useWebData } from "../../Context/webDataContext";

// const ContactUs = () => {
//   const { getContactPageData } = useWebData();
//   const contactData = getContactPageData();

//   return (
//     <>
//       <div className="relative">
//         <Navbar />
//         <section className="container mx-auto px-6 py-16 my-16">
//           <h2 className="text-center text-3xl font-bold mb-4">
//             {contactData.contactHeading}
//           </h2>
//           <p className="text-center text-lg text-gray-600 mb-10">
//             {contactData.contactSubHeading}
//           </p>
//           <div className="flex flex-col lg:flex-row items-center gap-10">
//             {/* Contact Information */}
//             <div className="bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white p-8 rounded-lg shadow-lg w-full lg:w-1/2">
//               <h3 className="text-xl font-semibold mb-6">Get in Touch</h3>
//               <div className="space-y-4">
//                 <p>
//                   <strong>Call Today:</strong> {contactData.contactInfo.phone}
//                 </p>
//                 <p>
//                   <strong>Email:</strong> {contactData.contactInfo.email}
//                 </p>
//                 <p>
//                   <strong>Address:</strong> {contactData.contactInfo.address}
//                 </p>
//               </div>
//             </div>
//             {/* Contact Form */}
//             <ContactForm />
//           </div>
//         </section>
//         <Footer />
//       </div>
//     </>
//   );
// };

// export default ContactUs;




